<template>
    <modal name="photo-delete-modal" :pivotY="0.2" height="auto">
        <div class="modal-close-btn-point">
            <div class="modal-close-btn-container" v-on:click="hideModal('photo-delete-modal')">
                <SVGModalClose/>
            </div>
        </div>
        <div class="modal-title-big">
            Удалить фотографии
        </div>
        <div class="modal-text">
            Удалить выбранные фото из проекта?
        </div>
        <vue-custom-scrollbar class="modal-photo-carousel">
            <div v-for="(img, key) in selectedPhotos">
                <img class="modal-photo-carousel-element" :src="urlForFileStorage(img.src)"/>
            </div>
        </vue-custom-scrollbar>
        <div class="modal-button" @click="removePhotos">
            Удалить
        </div>
    </modal>
</template>

<script>
    import {modalMethods, urlForFileStorage, urlForStaticVue} from "../common";
    import SVGModalClose from "../SVG/SVGModalClose.vue";
    import vueCustomScrollbar from 'vue-custom-scrollbar'

    export default {
        name: "ModalDeletePhoto",
        mixins: [modalMethods, urlForFileStorage, urlForStaticVue],
        computed: {
            selectedPhotos() {
                if (this.$store.getters[`active/GET_SELECTED_PHOTOS`].length)
                    return this.$store.getters[`active/GET_SELECTED_PHOTOS`]
                else if (this.$store.getters[`active/GET_ACTIVE_PHOTO`])
                    return [this.$store.getters[`active/GET_ACTIVE_PHOTO`]]
                else
                    return [{src: null}]
            }
        },
        methods: {
            removePhotos() {
                const guidActiveProject = this.$store.state.route.params.projectUUID;
                this.$store.dispatch('active/DELETE_PHOTOS');
                if(!this.$store.getters['active/CHECK_ACTIVE_PHOTO']){
                    this.$router.replace({
                        name: "loadPhoto",
                        params: {projectUUID: guidActiveProject}
                    }).catch(() => {})
                }
                this.hideModal('photo-delete-modal');
            }
        },
        components: {
            SVGModalClose,
            vueCustomScrollbar
        }
    }
</script>

<style scoped>

</style>
